"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsTableSaveOutcome = void 0;
var RatingsTableSaveOutcome;
(function (RatingsTableSaveOutcome) {
    RatingsTableSaveOutcome["Saved"] = "saved";
    RatingsTableSaveOutcome["Refused"] = "refused";
})(RatingsTableSaveOutcome || (exports.RatingsTableSaveOutcome = RatingsTableSaveOutcome = {}));
//# sourceMappingURL=ratings-table.types.js.map